import { useEffect, useState } from "react";
import Logo from "../Images/Logo.png";

const LOADER_SEEN_KEY = "techtopia-loader-seen";

function hasSeenLoader() {
  try {
    return localStorage.getItem(LOADER_SEEN_KEY) === "1";
  } catch {
    return false;
  }
}

function rememberLoader() {
  try {
    localStorage.setItem(LOADER_SEEN_KEY, "1");
  } catch {
    // Private browsing can block storage; the splash still closes.
  }
}

function PageLoader() {
  const [phase, setPhase] = useState(() => (hasSeenLoader() ? "done" : "show"));

  useEffect(() => {
    if (hasSeenLoader()) {
      setPhase("done");
      return undefined;
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const visibleFor = reduceMotion ? 400 : 1800;
    const fadeFor = reduceMotion ? 0 : 800;

    const leaveTimer = setTimeout(() => {
      rememberLoader();
      setPhase("leave");
    }, visibleFor);
    const doneTimer = setTimeout(() => setPhase("done"), visibleFor + fadeFor);

    return () => {
      clearTimeout(leaveTimer);
      clearTimeout(doneTimer);
    };
  }, []);

  if (phase === "done") return null;

  return (
    <div
      className={`page-loader${phase === "leave" ? " is-leaving" : ""}`}
      role="status"
      aria-label="Loading TechTopia"
    >
      <div className="page-loader-glow" aria-hidden="true" />
      <div className="page-loader-ring" aria-hidden="true" />
      <img src={Logo} alt="TechTopia" className="page-loader-logo" />
    </div>
  );
}

export default PageLoader;
